import $ from 'jquery';
import moment from 'moment';
import Framework from 'framework';
import UrlUtils from 'lib/url-utils';
import constants from 'lib/constants';
import profileStore from 'framework/stores/ProfileStore';
import formTracking from 'lib/form-tracking';
import FormUtils from 'lib/form-utils';
import profileStoreIsAvailable from 'lib/profile-store-utils';

function getMemberFieldState() {
	var state = 'prospect';
	if($('.is-member-field input#isMember').prop('checked')) {
		state = 'member';
	}
	return state;
}

function checkCasl() {
	var clubLocation = $('#ltf_mmsclubid option:selected').parent().attr('label');
	if(clubLocation === 'Canada') {
		var memFieldState = getMemberFieldState();
		if(memFieldState === 'prospect') {
			$('#disclaimer1').attr('required', 'true');
			$('#disclaimer1').addClass('required');
			$('#disclaimer-cn').show();
		}else{
			$('#disclaimer1').removeAttr('required');
			$('#disclaimer1').removeClass('required');
			$('#disclaimer-cn').hide();
		}
	}else{
		$('#disclaimer1').removeAttr('required');
		$('#disclaimer1').removeClass('required');
		$('#disclaimer-cn').hide();
	}
}

$(() => {
	var parsleyConfig = {
		trigger: 'change',
		errorClass: 'has-danger',
		classHandler: function (el) {
			return el.$element.closest('.form-group'); //working
		},
		errorsWrapper: '<ul class="label-help"></ul>'
	};
	var formObj = $('#contactUs');
	if(formObj.length > 0){
		if(globalCrmWebhook){
			if(navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function(position) {
					window.currentLatitude = position.coords.latitude;
					window.currentLongitude = position.coords.longitude;
				});
			}
			console.log('Using CRM Webhook');
			formObj.on('submit', function(e) {
				e.preventDefault();
				if($(this).parsley().isValid() ) {
					const targetUrl = Framework.global.lt.api.apimUrl + globalCrmWebhook;
					let obj = FormUtils.serializerFormToJson(formObj);
					let mappedObj = FormUtils.mapFormObjecToCRM(obj);
					$.ajax({
						url: targetUrl,
						type: 'post',
						dataType: 'json',
						headers: {
							'Ocp-Apim-Subscription-Key': Framework.global.lt.api.apimKey
						},
						data: JSON.stringify(mappedObj),
						success: function (result) {
							window.location.href = crmConfirmationPath;
						},
						error: function(xhr, status, error){
							window.location.href = crmErrorPath;
						}
					});
				}
			});
		}
		formObj.parsley(parsleyConfig);
		formObj.parsley().on('form:validated', function (e) {
			if(e.validationResult) {
				/* Validation has passed, prevent double form submissions */
				formObj.find('button[type=submit]').attr('disabled', true);
			}
		});
		formTracking();
	}
    // check for authentication state (if profile store is available)
    if (profileStoreIsAvailable) {
        let profileData = profileStore.getInitialData();

        if (profileData.memberState !== constants.memberState.unknown) {
            if (profileData.memberState === constants.memberState.authenticated || profileData.memberState === constants.memberState.remembered) {
                if (profileData.memberDetails && (profileData.memberDetails.memberType == null || typeof profileData.memberDetails.memberType === 'undefined')) {
                    // if authenticated user is a non-member set the input to "No" and hide field
                    $('.is-member-field input#notMember').prop('checked', true);
                    $('.is-member-field').hide();
                } else {
                    // if authenticated user is a member set the input to "Yes" and hide field
                    $('.is-member-field input#isMember').prop('checked', true);
                    $('.is-member-field').hide();
                }
            }
        } else {
            // listen for profileStore changes and update the form as above
            var unsubToProfileStore = profileStore.listen((profile) => {
                if (profile.memberState === constants.memberState.authenticated || profile.memberState === constants.memberState.remembered) {
                    if (profile.memberDetails && (profile.memberDetails.memberType == null || typeof profile.memberDetails.memberType === 'undefined')) {
                        // if authenticated user is a non-member set the input to "No" and hide field
                        $('.is-member-field input#notMember').prop('checked', true);
                        $('.is-member-field').hide();
                    } else {
                        // if authenticated user is a member set the input to "Yes" and hide field
                        $('.is-member-field input#isMember').prop('checked', true);
                        $('.is-member-field').hide();
                    }
                }
                unsubToProfileStore();
            });
        }
    }

	// add casl legal input when both canadian club is selected and necessary member requirement is met
	$('#ltf_mmsclubid, input#isMember, input#notMember').on('change', ()=> {
		checkCasl();
	});

	$('#disclaimer1').on('change', ()=> {
		if($('#disclaimer1').is(':visible') && $('#disclaimer1').prop('checked')) {
			$('input[name="ltf_communicationconsent"]').val('960600000');
			$('input[name="ltf_consentdatetime"]').val(moment().format('YYYY-MM-DD HH:mm:ss'));
		}else{
			$('input[name="ltf_communicationconsent"]').val('960600001');
		}

	});

	// populate recipient field from club info
	if(Framework.global.lt.club) {
		$('#ltf_mmsclubid').val(Framework.global.lt.club.mmsClubId);
		checkCasl();
	}else{
		// populate recipient field if parameter is present
		let recipient = UrlUtils.getUrlParameter('recipient');

		if(recipient && recipient !== '') {
			$('#ltf_mmsclubid').val(recipient);
			checkCasl();
		}
	}

	// populate group field if parameter is present
	let group = UrlUtils.getUrlParameter('group');

	if(group && group !== '') {
		$('#ltf_group').val(group);
	}
});
